










import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';

@Component
export default class VirtualCategoryBadges extends Vue {
  @Prop({required: true})
  public virtualCategories: string[];

  private MAX_BRAND_ICONS_DISPLAYED = 2;

  get iconUrlsByBrandId(): Map<string, string> {
    return new Map([
      ['RIED', '/images/virtual_categories/OurTipp.svg'],
      ['COOK', '/images/virtual_categories/Cook.png'],
      ['NATÜR', '/images/virtual_categories/NatuerlichFuerUns.png'],
      ['ECO', '/images/virtual_categories/TransGourmetEconomy.png'],
      ['NAT', '/images/virtual_categories/TransGourmetNatura.png'],
      ['PREMI', '/images/virtual_categories/TransGourmetPremium.png'],
      ['QUALI', '/images/virtual_categories/TransGourmetQuality.png'],
      ['VONA', '/images/virtual_categories/TransGourmetVonatur.png'],
      ['CONVI', '/images/virtual_categories/Convenience.svg'],
    ]);
  }

  get iconIds(): string[] {
    return this.virtualCategories
        .filter((it) => this.iconUrlsByBrandId.has(it))
        .slice(0, this.MAX_BRAND_ICONS_DISPLAYED);
  }

  get shouldDisplayIcons(): boolean {
    return this.iconIds.length > 0;
  }

  private getIconTitle(iconId: string) {
    const asciiIconId = this.replaceUmlautUSinceTranslationCantHandleIt(iconId);

    return this.$t(`common.product.virtualCategories.${asciiIconId}`);
  }

  private replaceUmlautUSinceTranslationCantHandleIt(iconId: string): string {
    return iconId.replace('Ü', 'U');
  }
}
